<template>
  <v-container>
    <img src="../../assets/breadcrumb1.svg" />
    <h1>Who are the Directors of the corporation?</h1>
    <v-form ref="form">
      <PeopleField v-model="director" label="director" />
      <v-text-field
        v-model="officers.president"
        :rules="[required]"
        label="President"
        data-cy="president"
      />
      <v-text-field
        v-model="officers.treasurer"
        :rules="[required]"
        label="Treasurer"
        data-cy="treasurer"
      />
      <v-text-field
        v-model="officers.secretary"
        :rules="[required]"
        label="Secretary"
        data-cy="secretary"
      />
      <v-text-field
        v-model="officers.vice"
        :rules="[required]"
        label="Vice President"
        data-cy="vice"
      />
      <v-layout wrap>
        <v-flex :class="breakpointMargin" xs12 sm6>
          <v-text-field
            v-model="share.num"
            :rules="[required]"
            label="Number of Authorized Shares"
            data-cy="share-num"
          />
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="share.val"
            :class="breakpointMargin"
            :rules="[required]"
            label="Share Par Value"
            data-cy="share-val"
          />
        </v-flex>
      </v-layout>
      <v-layout justify-space-around>
        <v-btn @click="$router.go(-1);">Back</v-btn>
        <v-btn color="info" @click="done">Continue</v-btn>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';
import PeopleField from '../util/PeopleField.vue';

const db = firebase.database;

export default {
  components: { PeopleField },
  data: () => ({
    director: [''],
    officers: {
      president: '',
      secretary: '',
      treasurer: '',
      vice: '',
    },
    share: {
      num: 0,
      val: 0,
    },
  }),
  computed: {
    ...mapState(['token']),
    breakpointMargin() {
      return {
        'mx-2': this.$vuetify.breakpoint.smAndUp,
      };
    },
  },
  methods: {
    async done() {
      if (!this.$refs.form.validate()) return;
      this.director = this.director.filter(n => !!n);
      await db()
        .ref(`info/${this.token}`)
        .update(this.$data);
      this.$router.push({ path: '/stage4/agent' });
    },
    required: field => !!field || 'This field is required',
  },
};
</script>
